import { Collection } from '@features/product/components/Collection/Collection.types';

export const getCurrentProductValues = (collection: Collection) => {
  const currentProductValues: string[] = [];

  collection.discriminants.forEach(discriminant =>
    currentProductValues.push(
      discriminant.values.find(value => value.isValueOfCurrentProduct)?.name ?? ''
    )
  );

  return currentProductValues;
};
